import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ROUTER_BACKOFFICE } from 'app/AppRouter';
import Promotion from 'pages/BackOfficePage/BackOfficeCategories/Promotion/Promotion/Promotion';
import { COPY, CREATE_NEW, EDIT, PROMOTION } from 'pages/BackOfficePage/BackOfficePage.type';

export function PromotionBase() {
  return (
    <Switch>
      <Route
        exact
        path={`${ROUTER_BACKOFFICE}/${PROMOTION}/${CREATE_NEW}`}
        render={() => <Promotion modalType={'create'} />}
      />
      <Route
        exact
        path={`${ROUTER_BACKOFFICE}/${PROMOTION}/${EDIT}/:promotionId`}
        render={() => <Promotion modalType={'edit'} />}
      />
      <Route
        exact
        path={`${ROUTER_BACKOFFICE}/${PROMOTION}/${COPY}/:promotionId`}
        render={() => <Promotion modalType={'copy'} />}
      />
      <Route exact path={'*'} render={() => <Promotion />} />
    </Switch>
  );
}
